import { render, staticRenderFns } from "./DamageInformation.vue?vue&type=template&id=6be378a6&"
import script from "./DamageInformation.vue?vue&type=script&lang=js&"
export * from "./DamageInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAutocomplete,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6be378a6')) {
      api.createRecord('6be378a6', component.options)
    } else {
      api.reload('6be378a6', component.options)
    }
    module.hot.accept("./DamageInformation.vue?vue&type=template&id=6be378a6&", function () {
      api.rerender('6be378a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/equipment/customComponents/DamageInformation.vue"
export default component.exports